import { SimpleModalService } from '../../../shared/dialogs/simple-modal.service'
import { Inject, Injectable } from '@angular/core'
import { NotificationDetailDialogComponent } from '../dialogs/notification-detail/notification-detail-dialog.component'
import { HelpdeskDialogComponent } from '../dialogs/helpdesk/helpdesk-dialog.component'

@Injectable({
    providedIn: 'root'
})
export class MainDialogService {

    constructor(@Inject(SimpleModalService) private simpleModalService: SimpleModalService) {
    }

    showHelpdesk(): void {
        this.simpleModalService.addModal(HelpdeskDialogComponent)
    }

    showNotificationDetailDialog(): void {
        this.simpleModalService.addModal(NotificationDetailDialogComponent)
    }
}